import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import LoadingSpinner from './components/LoadingSpinner';

// Lazy load pages for code-splitting
const Monitor = lazy(() => import('./pages/Monitor'));
const GerarOS = lazy(() => import('./pages/GerarOS'));
const BaseClientes = lazy(() => import('./pages/BaseClientes'));
const Status = lazy(() => import('./pages/Status'));
const Orcamento = lazy(() => import('./pages/Orcamento'));
const Caixa = lazy(() => import('./pages/Caixa'));
const EnvioPix = lazy(() => import('./pages/EnvioPix'));
const Dashboard = lazy(() => import('./pages/Dashboard'));

function App() {
  return (
    <Layout>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<Monitor />} />
          <Route path="/os/nova" element={<GerarOS />} />
          <Route path="/clientes" element={<BaseClientes />} />
          <Route path="/os/:id/status" element={<Status />} />
          <Route path="/os/:id/orcamento" element={<Orcamento />} />
          <Route path="/caixa" element={<Caixa />} />
          <Route path="/pix" element={<EnvioPix />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </Suspense>
    </Layout>
  );
}

export default App;



